/**
* photo div JS
* -----------------------------------------------------------------------------
*
* All the JS for the photo div component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'photo-div',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.photo-div',
          scrub: true,
          start: '-75% bottom',
          end: '+175%',
          // markers: true,
        },
      } );

      tl.from( '.ll-photo-div__photo', {
        y: '-6rem',
        // ease: 'ease-in-out',
      } );

      tl.to( '.ll-photo-div__photo', {
        y: '6rem',
        // ease: 'ease-in-out',
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'photo-div', COMPONENT );
} )( app );
